const JOIN_ROOM = 'zen/pipe/JOIN_ROOM';
const LEAVE_ROOM = 'zen/pipe/LEAVE_ROOM';
const LEAVE_ENTITY = 'zen/pipe/LEAVE_ENTITY';
const SOCKET_RECONNECT = 'zen/pipe/SOCKET_RECONNECT';

export {
  JOIN_ROOM, LEAVE_ROOM, LEAVE_ENTITY, SOCKET_RECONNECT
};
